import React from "react";
import "./index.scss";

const RecordingAnimation = () => {
  return <div className="custom-loader" />;
};

export default RecordingAnimation;
